import React from "react";
import { Switch, Route } from 'react-router-dom';

import MainPage from "../pages/mainPage.component";
import About from "../pages/about.component";
import ListPage from "../pages/listPage.component";
import ArticlePage from "../pages/articlePage.component";
const Router = (p) => {
  const [action, store] = [p.action, p.store.getState()];

  return (
    <Switch>
      <Route exact path={"/"} render={() => <MainPage store={store} action={action} />}/>
      <Route exact path={"/about"} render={() => <About store={store} action={action} />}/>

      <Route exact path={[
        "/originala-prozo", 
        "/originala-poezio",
        "/tradukita-prozo",
        "/tradukita-poezio",
        "/tradukitaj-kantoj",
        "/eseoj",
        "/recenzoj",
        "/teatraĵoj",
        "/ruslingvaĵoj/recenzoj",
        "/ruslingvaĵoj/rezonadoj",
        "/ruslingvaĵoj/rakontoj",
        "/ruslingvaĵoj/rimaĵoj",
        "/ruslingvaĵoj/teatraĵoj",
        "/ruslingvaĵoj/tradukoj",
      ]} render={
        () => <ListPage store={store} action={action} />
      }/>
      <Route exact path={[
        "/originala-prozo/:name", 
        "/originala-poezio/:name",
        "/tradukita-prozo/:name",
        "/tradukita-poezio/:name",
        "/tradukitaj-kantoj/:name",
        "/eseoj/:name",
        "/recenzoj/:name",
        "/teatraĵoj/:name",
        "/ruslingvaĵoj/recenzoj/:name",
        "/ruslingvaĵoj/rezonadoj/:name",
        "/ruslingvaĵoj/rakontoj/:name",
        "/ruslingvaĵoj/teatraĵoj/:name",
        "/ruslingvaĵoj/tradukoj/:name",
        "/ruslingvaĵoj/rimaĵoj/:name",
        "/ruslingvaĵoj/formoj_malgrandaj",
      ]} render={
        () => <ArticlePage store={store} action={action} />
      }/>

    </Switch>
  )
}


export default Router;